import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "../css/AddExpense.css";

const AddExpense = () => {
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const location = useLocation();
  const passedExpense = location.state?.expense;
  const [form, setForm] = useState({
    item_name: "",
    description: "",
    amount: "",
    purchase_date: "",
    payment_type: "Cash",
  });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const navigate = useNavigate();

  useEffect(() => {
    if (isEditMode && passedExpense) {
      setForm({
        item_name: passedExpense.item_name || "",
        description: passedExpense.description || "",
        amount: passedExpense.amount || "",
        purchase_date: passedExpense.purchase_date || "",
        payment_type: passedExpense.payment_type || "Cash",
      });
    } else if (!isEditMode) {
      setForm({
        item_name: "",
        description: "",
        amount: "",
        purchase_date: "",
        payment_type: "Cash",
      });
    }
  }, [isEditMode, passedExpense]);

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: '', type: '' });
    }, 3000);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const API_URL = process.env.REACT_APP_API_URL || "";
      let response, data;
      if (isEditMode) {
        response = await fetch(`${API_URL}edit-expense.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id,
            ...form,
            amount: Number(form.amount),
          }),
        });
        data = await response.json();
        if (!response.ok || data.status === false) throw new Error(data.message || "Failed to update expense");
        showToast("Expense updated successfully!", "success");
      } else {
        response = await fetch(`${API_URL}add-expense.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...form,
            amount: Number(form.amount),
          }),
        });
        data = await response.json();
        if (!response.ok || data.status === false) throw new Error(data.message || "Failed to add expense");
        showToast("Expense added successfully!", "success");
        setForm({
          item_name: "",
          description: "",
          amount: "",
          purchase_date: "",
          payment_type: "Cash",
        });
      }
      setTimeout(() => {
        navigate("/expense-list");
      }, 1500);
    } catch (err) {
      showToast(err.message || (isEditMode ? "Error updating expense" : "Error adding expense"), "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-expense-content">
      <div className="page-header">
        <h2>{isEditMode ? "Edit Expense" : "Add Expense"}</h2>
      </div>
      <div className="form-container">
        <form onSubmit={handleSubmit} className="add-expense-form">
          <div className="form-group">
            <label>Item Name</label>
            <input
              type="text"
              name="item_name"
              value={form.item_name}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label>Description</label>
            <input
              type="text"
              name="description"
              value={form.description}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label>Amount</label>
            <input
              type="number"
              name="amount"
              value={form.amount}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label>Purchase Date</label>
            <input
              type="date"
              name="purchase_date"
              value={form.purchase_date}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label>Payment Type</label>
            <select
              name="payment_type"
              value={form.payment_type}
              onChange={handleChange}
              required
              disabled={loading}
            >
              <option value="Cash">Cash</option>
              <option value="Card">Card</option>
              <option value="UPI">UPI</option>
            </select>
          </div>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? (isEditMode ? "Updating..." : "Adding...") : (isEditMode ? "Update Expense" : "Add Expense")}
          </button>
        </form>
        {toast.show && (
          <div className={`toast toast-${toast.type}`}>
            <div className="toast-content">
              <span className="toast-message">{toast.message}</span>
              <button
                className="toast-close"
                onClick={() => setToast({ show: false, message: '', type: '' })}
              >
                ×
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddExpense; 